import { render, staticRenderFns } from "./DesignSearchItem.vue?vue&type=template&id=a1c6b704&scoped=true&"
import script from "./DesignSearchItem.vue?vue&type=script&lang=js&"
export * from "./DesignSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./DesignSearchItem.vue?vue&type=style&index=0&id=a1c6b704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c6b704",
  null
  
)

export default component.exports